import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { READONLY_CONTEXT_ERROR } from '../constants/viewAs.constants';

export function isReadonlyContextError(error: unknown): boolean {
    return error instanceof HttpErrorResponse
        && error.status === HttpStatusCode.Forbidden
        && typeof error.error === 'string'
        && error.error.trim() === READONLY_CONTEXT_ERROR;
}
